import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import InformationIcon from '@atlaskit/icon/core/information';
import LegacyInfoIcon from '@atlaskit/legacy-custom-icons/info-icon';
export var InfoIcon = function InfoIcon(props) {
  return /*#__PURE__*/React.createElement(InformationIcon, _extends({
    color: props.color || 'currentColor',
    LEGACY_fallbackIcon: LegacyInfoIcon
  }, props));
};